export default Object.freeze({
  /** Paginated list envelope mirrors the server response shape: { rows, totalCount, page, pageSize, sortBy, sortDir, search, status, mobilePatrolID }. */
  list: {
    rows: [],
    totalCount: 0,
    page: 1,
    pageSize: 25,
    sortBy: null,
    sortDir: null,
    search: '',
    status: null,
    mobilePatrolID: null,
  },
  /** Currently selected route detail (RouteDetail) or null. */
  selected: null,
  /** Per-route paginated run history map: { [mobileRouteID]: { rows, totalCount, page, pageSize } }. */
  runHistory: {},
  /** Cross-route runs working set for the Operations "Mobile Route Runs" page. Mirrors GET /mobile-routes/runs: { rows: RunListItem[], totalCount }. */
  runsList: {
    rows: [],
    totalCount: 0,
    page: 1,
    pageSize: 25,
    /** Server-supplied end-reason counts for the status chips: { all, completed, manually, autoEnded }. */
    counts: null,
  },
  /** Currently selected run detail (RunDetail) or null. */
  selectedRun: null,
  /** Last-error map keyed by operation (e.g. create, update, copy, suspend, resume, delete). */
  errors: {},
  /** Per-operation loading flags (true while a request is in flight). */
  loading: {},
});
